import SubcategoryPage from '@/components/template/SubcategoryPage';

const DobroPocutje = () => {
  const products = [
    {
      title: "Dobro Počutje Omarica",
      imageSrc: "https://images.unsplash.com/photo-1584622650111-993a426fbf0a?auto=format&fit=crop&q=80",
      url: "/pohistvo/dobro-pocutje/omarica"
    },
    {
      title: "Dobro Počutje Polica",
      imageSrc: "https://images.unsplash.com/photo-1600566752610-111d521cf1de?auto=format&fit=crop&q=80",
      url: "/pohistvo/dobro-pocutje/polica"
    },
    {
      title: "Dobro Počutje Ogledalo",
      imageSrc: "https://images.unsplash.com/photo-1617004518200-f3b8191fdc1d?auto=format&fit=crop&q=80",
      url: "/pohistvo/dobro-pocutje/ogledalo"
    },
    {
      title: "Dobro Počutje Komoda",
      imageSrc: "https://images.unsplash.com/photo-1600566752427-25ef8fb4e018?auto=format&fit=crop&q=80",
      url: "/pohistvo/dobro-pocutje/komoda"
    },
    {
      title: "Dobro Počutje Stol",
      imageSrc: "https://images.unsplash.com/photo-1629079447777-1e605162dc8d?auto=format&fit=crop&q=80",
      url: "/pohistvo/dobro-pocutje/stol"
    },
    {
      title: "Dobro Počutje Set",
      imageSrc: "https://images.unsplash.com/photo-1602028915047-37269d1a73f7?auto=format&fit=crop&q=80",
      url: "/pohistvo/dobro-pocutje/set"
    }
  ];

  return (
    <SubcategoryPage
      title="Kolekcija Dobro počutje"
      description="Raziščite našo luksuzno kolekcijo pohištva za dobro počutje, ki združuje udobje, funkcionalnost in vrhunsko obrtno izdelavo za vašo sproščujočo oazo."
      heroImage="https://images.unsplash.com/photo-1584622650111-993a426fbf0a?auto=format&fit=crop&q=80"
      products={products}
    />
  );
};

export default DobroPocutje;